module.exports = __webpack_public_path__ + "img/plus.267536ba.svg";